import { useQuery } from '@tanstack/react-query';
import { GET } from '../services/index';

/**
 * การตั้งค่าแจ้งเตือนของบริษัท (admin ตั้งที่หน้าหลังบ้าน)
 *
 * ตั้งใจไม่ poll — ค่าพวกนี้เปลี่ยนนาน ๆ ครั้ง ถ้าตั้ง refetchInterval จะกลายเป็น
 * request งอกอีกเส้นให้ทุกเครื่องยิงตลอดเวลา (บทเรียนจากตอนไล่แก้ระบบหน่วง)
 * staleTime 5 นาที = admin แก้แล้วพนักงานได้ค่าใหม่ภายใน 5 นาทีโดยไม่ต้องรีเฟรช
 */
export const useNotificationSetting = () => {
  const query = useQuery(
    ['notificationSetting'],
    async () => {
      const { result } = await GET('/api/v1/notificationSetting');
      return result;
    },
    {
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    }
  );

  const byType = (alertType) =>
    (query.data || []).find((s) => s.alertType === alertType) || null;

  return { ...query, byType };
};

export default useNotificationSetting;
